import { searchLenders } from '@funnels/api';
import { Lender } from '@funnels/types';

export default function loadLenders(query?: string) {
  return searchLenders(query).then((lenders: Lender[]) => {
    return lenders.map((lender) => ({
      label: lender.name,
      value: lender.name,
    }));
  });
}
